module.exports = __webpack_public_path__ + "img/check-bullet.f6cd6629.svg";